export const SpaceHorizontalClasses = {
  SPACE_NONE: ['wf-space-x-0'],
  SPACE_XXS: ['wf-space-x-2'],
  SPACE_XS: ['wf-space-x-4'],
  SPACE_SSM: ['wf-space-x-8'],
  SPACE_SM: ['wf-space-x-12'],
  SPACE_MD: ['wf-space-x-20'],
  SPACE_LG: ['wf-space-x-32'],
  SPACE_XL: ['wf-space-x-48'],
}

export const SpaceVerticalClasses = {
  SPACE_NONE: ['wf-space-y-0'],
  SPACE_XXS: ['wf-space-y-2'],
  SPACE_XS: ['wf-space-y-4'],
  SPACE_SSM: ['wf-space-y-8'],
  SPACE_SM: ['wf-space-y-12'],
  SPACE_MD: ['wf-space-y-20'],
  SPACE_LG: ['wf-space-y-32'],
  SPACE_XL: ['wf-space-y-48'],
}